var path = '/modules/messages/views/pages/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/messages/views/pages/list.tpl.html
// module id = 2140
// module chunks = 1